import React from "react";
import { Link } from "react-router-dom";

const Nav = () => {
  return (
    <div className="nav">
      <div className="ui stackable secondary pointing menu">
        <div className="right menu" style={{fontFamily:'roboto slab',color:'grey'}}>
          <Link className="item" to="/">
            About
          </Link>
          <Link className="item" to="/experiences">
            Experiences
          </Link>
          <Link className="item" to="/projects">
            Projects
          </Link>
          <Link className="item" to="/external">
            External Links
          </Link>
          <Link className="item" to="/contact">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Nav;
